import React from 'react';
import { ArrowDown } from 'lucide-react';
import { architectureLayers } from '../../data/howItWorks';

/** Top-down architecture overview; each layer links to its detailed section below. */
export function ArchitectureStack() {
  return <nav aria-label="SyNeural architecture, from foundation to solutions" data-id="element-1167" data-mp="1g4zqz8qstynh">
      <ol className="rounded-xl border border-line bg-white overflow-hidden" data-id="element-1168" data-mp="1kycaj4gmff9d">
        {architectureLayers.map((layer, index) => {
        const isFoundation = index < 2;
        return <li key={layer.id} className="border-b border-line last:border-b-0" data-id="element-1169" data-mp="1twxqqsymei6z" data-mpi={index}>
              <a href={`#${layer.id}`} className={`group grid grid-cols-1 md:grid-cols-12 items-center gap-1 md:gap-8 px-5 sm:px-6 py-5 transition-colors duration-150 hover:bg-surface-muted focus-visible:outline focus-visible:outline-2 focus-visible:-outline-offset-2 focus-visible:outline-teal ${isFoundation ? 'bg-surface-bg' : ''}`} data-id="element-1170" data-mp="1ywir97tfuylt">
                <span className="md:col-span-3 flex items-center gap-3" data-id="element-1171" data-mp="6ratp7websda">
                  <span aria-hidden="true" className="inline-flex h-7 w-7 shrink-0 items-center justify-center rounded-full border border-teal/60 text-sm font-semibold text-teal" data-id="element-1172" data-mp="1z0xja4otw2k">
                    {index + 1}
                  </span>
                  <span className="text-sm font-medium text-ink-muted" data-id="element-1173" data-mp="pov8tn9czckp">{layer.level}</span>
                </span>
                <span className="md:col-span-4 pl-10 md:pl-0 font-heading font-bold text-lg text-ink-dark group-hover:text-navy transition-colors duration-150" data-id="element-1174" data-mp="kpr0szy67kvy">
                  {layer.name}
                </span>
                <span className="md:col-span-5 pl-10 md:pl-0 text-ink-muted leading-relaxed" data-id="element-1175" data-mp="boascxqx1sud">{layer.role}</span>
              </a>
            </li>;
      })}
      </ol>
      <p className="mt-4 flex items-center gap-2 text-sm text-ink-muted" data-id="element-1176" data-mp="2wf1ss969hjj1">
        <ArrowDown size={14} aria-hidden="true" className="text-teal" data-id="element-1177" data-mp="2whxmflb2tm1o" />
        Each layer builds on the one above it. Select a layer to jump to its detail.
      </p>
    </nav>;
}